<template>
  <div v-if="supportedLanguages && supportedLanguages.length > 1" class="locale-changer flex">
    <img class="laguage-icon" src="@/assets/icons/language_selection.svg" />
    <drop-down-list
      :data-items="localesList"
      :text-field="'text'"
      :data-item-key="'id'"
      :default-value="selectedLanguage"
      @change="setLocale"
      :popupSettings="{
        className: 'ib-login-dropdown'
      }"
      size="large"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useI18n } from "vue-i18n";
import { Languages } from "@/modules/login/models/languages";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
const { locale, availableLocales } = useI18n({ useScope: "global" });
import { useStore } from "vuex";

// store composable
const store = useStore();

// refs
const localesList = ref([]);
const selectedLanguage = ref({});
const languages = ref({
  en: Languages.ENGLISH,
  fr: Languages.FRENCH,
  it: Languages.ITALIAN,
  swe: Languages.SWEDEN,
});

// computed
const supportedLanguages = computed(() => store.state.config.locale.supported_languages);

// methods
const setLocale = (event) => {
  locale.value = event.value.id;
  window.localStorage.locale = locale.value;
};

onMounted(() => {
  let currentLocale = store.state.config.locale.primary;
  if (supportedLanguages.value && supportedLanguages.value.length > 1) {
    currentLocale = window.localStorage.locale || store.state.config.locale.primary
  }
  setLocale({value: {id: currentLocale}});
  if (!supportedLanguages.value || supportedLanguages.value.length < 2) return;
  localesList.value = availableLocales
    .filter((i18nLocale) => {
      return supportedLanguages.value.includes(i18nLocale);
    })
    .map((locale) => {
      return {
        text: languages.value[locale],
        id: locale,
      };
    });
  selectedLanguage.value = {
    text: languages.value[locale.value],
    id: locale.value,
  };
});
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  width: fit-content;
  align-items: center;
}

.laguage-icon {
  padding-right: 10px;
  height: 26px;
  color: white;
}

.k-dropdownlist {
  background-color: transparent;
  color: #fff;
  font-size: 26px;
  padding: 0;

  &:hover {
    background-color: transparent;
  }
  :deep(.k-input-inner) {
    padding: 0;
  }
  :deep(.k-i-caret-alt-down) {
    padding: 0;
    background-image: url(~@/assets/icons/inverted_caret.svg);
    background-size: 100%;
    min-height: auto !important;
    &:before {
      content: "";
    }
  }
}

@media (max-width: 1600px) {
  .k-dropdownlist {
  background-color: transparent;
  color: #fff;
  font-size: 22px;
  padding: 0;
  }
}
</style>

<style lang="scss">
.ib-login-dropdown.k-list-container.k-popup.k-child-animation-container {
  border-radius: 18px;
  overflow: hidden;
  width:100px;

  .k-list-item {
    color: #04023a;
    &.k-selected {
      background-color: #91afd2;
    }
  }
}
</style>
